import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiContentSectionDTO,
  ContentSectionDTO,
} from "@lib/strapi/dtos/components/sections/contentSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { getImageProps, ImageProps } from "@lib/image";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";

export class ContentSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiContentSectionDTO,
  ): Promise<ContentSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new ContentSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.style = strapiData.style;
    dto.heading = strapiData.heading;
    dto.subheading = strapiData.subheading;
    dto.content = await parseStrapiContent(strapiData.content);
    dto.image = getImageProps(strapiData.image);
    dto.links = await Promise.all(
      (strapiData.links ?? []).map(
        async (item) => await LinkService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }
}
